import { apiRequest } from './client.js';

/**
 * M05 Rejection Reason Master accessor (shared by M10 quality screens).
 *
 * §15 of the M10 spec mandates that rejection reasons are sourced from the
 * M05 Rejection Reason Master — never free-typed or hardcoded (LAW-6). The
 * `list` endpoint is auth-guarded but carries no extra permission, so any
 * authenticated reviewer can populate the reason picker.
 */
export interface RejectionReasonOption {
  readonly reasonId: string;
  readonly reasonCode: string;
  readonly reasonDescription: string;
  readonly requiresRemarks?: boolean;
  readonly sortOrder?: number;
}

/** Fetch the ACTIVE rejection reasons for the current tenant, ordered by sortOrder.
 *
 * Pass `moduleCode` (e.g. 'M10', 'M11') to scope the picker to that module's own
 * reason taxonomy plus any global (untagged) reasons. Omitting it preserves the
 * original "all reasons" behaviour. */
export async function listRejectionReasons(
  token: string | null,
  moduleCode?: string,
): Promise<readonly RejectionReasonOption[]> {
  const q = moduleCode
    ? `?status=ACTIVE&module=${encodeURIComponent(moduleCode)}`
    : '?status=ACTIVE';
  const rows = await apiRequest<readonly RejectionReasonOption[]>(
    `/v1/master/rejection-reasons${q}`,
    { token },
  );
  return Array.isArray(rows) ? rows : [];
}
